import React from "react"
import { ArticleContent, News } from "@sections"
import { Layout, Seo } from "@layout"

const ArticlePage = ({ pageContext }) => {
  return (
    <>
      <Seo pageData={pageContext.article} ogImage={pageContext.ogImage} />
      <div className="article">
        <Layout light>
          <ArticleContent article={pageContext.article} />
          <News strictTitle="További aktualitások" />
        </Layout>
      </div>
    </>
  )
}

export default ArticlePage